import { SxProps, Theme } from '@mui/material';
import { atlasCore, atlasSemantic } from 'src/theme/atlas/tokens';

export const card = (selected: boolean): SxProps<Theme> => ({
  flex: 1,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  p: '20px',
  backgroundColor: atlasSemantic.color.surface.default,
  border: `1px solid ${
    selected
      ? atlasSemantic.color.selection.primary.default
      : atlasSemantic.color.ui.divider.default
  }`,
  borderRadius: atlasCore.radius.lg,
  boxShadow: selected ? atlasSemantic.shadow.focus : 'none',
  '&:hover': { borderColor: atlasSemantic.color.outline.hover },
  '&:focus-visible': {
    outline: `2px solid ${atlasSemantic.color.ui.focusRing}`,
  },
  justifyContent: 'space-between',
});

export const labelRow: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};

export const label: SxProps<Theme> = {
  color: atlasSemantic.color.type.muted,
};

export const infoIcon: SxProps<Theme> = {
  color: atlasSemantic.color.type.muted,
  fontSize: '14px',
};

export const count: SxProps<Theme> = {
  fontSize: '36px',
  fontWeight: 600,
  lineHeight: 1.1,
};
